import React from 'react';
import colors from '../../utils/colors';

const RecordedWaveform = ({ 
  onClose,
  className = "",
  recordingWaveformData = [],
  progress = 0,
  isPlaying = false,
  showCloseButton = true
}) => {
  // Debug: Log waveform data for troubleshooting
  // console.log('RecordedWaveform props:', { recordingWaveformDataLength: recordingWaveformData.length, progress, isPlaying });
  
  // Temporary test data if recordingWaveformData is empty or has issues
  const testData = recordingWaveformData.length > 0 ? recordingWaveformData : 
    Array.from({ length: 50 }, () => Math.floor(Math.random() * 30) + 15);
  
  return (
    <div className={`w-full h-20 relative border border-white/10 rounded-xl ${className}`}>
      <div className="w-full h-12 absolute left-0 top-4 overflow-hidden px-3">
        <div className="flex justify-start items-center h-12 w-full overflow-hidden gap-0.5">
          {testData.map((height, index) => {
            const barProgress = index / testData.length;
            const barColor = barProgress <= progress ? colors.accent : colors.text.inactive;
            // Ensure minimum height and maximum height
            const barHeight = Math.max(8, Math.min(48, height));
            
            return (
              <div
                key={index}
                className="flex-grow-0 flex-shrink-0 w-px rounded-[100px]"
                style={{ 
                  height: `${barHeight}px`,
                  backgroundColor: barColor 
                }}
              />
            );
          })}
        </div>
      </div>
      
      {/* Progress Line - same style as main waveform - spans full container height */}
      <>
        {/* Invisible drag area */}
        <div 
          className="absolute top-0 bottom-0 w-3 cursor-grab transition-all duration-100 ease-linear"
          style={{ 
            left: `calc(0.75rem + ${progress} * (100% - 1.5rem) - 6px)`
          }}
        />
        {/* Visible progress line */}
        <div 
          className="absolute top-0 bottom-0 w-0.5 bg-white pointer-events-none transition-all duration-100 ease-linear"
          style={{ 
            left: `calc(0.75rem + ${progress} * (100% - 1.5rem))`
          }}
        />
      </>
      
      {/* Close button - only show when showCloseButton is true */}
      {showCloseButton && (
        <div className="flex justify-center items-center w-10 h-10 absolute right-2 bottom-2 gap-1 px-4 rounded-[100px] bg-white/[0.04] backdrop-blur-[50px] cursor-pointer hover:bg-white/[0.08] transition-colors" onClick={onClose}>
        <svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
          preserveAspectRatio="xMidYMid meet"
        >
          <path
            d="M8 8.93337L4.73334 12.2C4.61111 12.3223 4.45556 12.3834 4.26667 12.3834C4.07778 12.3834 3.92222 12.3223 3.8 12.2C3.67778 12.0778 3.61667 11.9223 3.61667 11.7334C3.61667 11.5445 3.67778 11.3889 3.8 11.2667L7.06667 8.00003L3.8 4.73337C3.67778 4.61114 3.61667 4.45559 3.61667 4.2667C3.61667 4.07781 3.67778 3.92225 3.8 3.80003C3.92222 3.67781 4.07778 3.6167 4.26667 3.6167C4.45556 3.6167 4.61111 3.67781 4.73334 3.80003L8 7.0667L11.2667 3.80003C11.3889 3.67781 11.5444 3.6167 11.7333 3.6167C11.9222 3.6167 12.0778 3.67781 12.2 3.80003C12.3222 3.92225 12.3833 4.07781 12.3833 4.2667C12.3833 4.45559 12.3222 4.61114 12.2 4.73337L8.93334 8.00003L12.2 11.2667C12.3222 11.3889 12.3833 11.5445 12.3833 11.7334C12.3833 11.9223 12.3222 12.0778 12.2 12.2C12.0778 12.3223 11.9222 12.3834 11.7333 12.3834C11.5444 12.3834 11.3889 12.3223 11.2667 12.2L8 8.93337Z"
            fill="#FAF7F5"
          />
        </svg>
        </div>
      )}
    </div>
  );
};

export default RecordedWaveform;